import { createSelector } from 'reselect';
import { chosenForYouMlTagsSelector } from 'selectors/testTarget/offers/chosenForYouMlTags/chosenForYouMlTagsSelector';

const showSelector = createSelector(chosenForYouMlTagsSelector, chosenForYouMlTags => !!chosenForYouMlTags.show);

export { showSelector };
